export default "<header><h2></h2></header>\n<div class=\"grid\"></div>\n";